import type { GoodsImages } from "./contracts";

export const PRIMARY_LOCALES = ["ko", "en", "ja"] as const;
export type PrimaryLocale = (typeof PRIMARY_LOCALES)[number];

export type Locale = PrimaryLocale | "zh-cn" | "zh-tw";

export type LocalizedText = Record<Locale, string>;

export function toLocalizedText(value: Partial<Record<Locale, string>> | undefined): LocalizedText {
  const v = (key: Locale) => value?.[key]?.trim() || "";
  const en = v("en");
  const ko = v("ko");
  const ja = v("ja");
  const fallback = en || ko || ja;

  return {
    ko: ko || fallback,
    en: en || fallback,
    ja: ja || fallback,
    "zh-cn": v("zh-cn") || fallback,
    "zh-tw": v("zh-tw") || fallback,
  };
}

export function sameText(text: string): LocalizedText {
  return { ko: text, en: text, ja: text, "zh-cn": text, "zh-tw": text };
}

export function resolveGoodsImage(images: GoodsImages | undefined, locale: Locale): string | null {
  if (!images) return null;
  if (locale === "ko" || locale === "en" || locale === "ja") {
    const direct = images[locale];
    if (direct) return direct;
  }
  return images.en || images.ko || images.ja || null;
}
